module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/Lb2XT5/images/cover.jpg?1704638967945",
      "alt": "This image is the cover for the book Britain's Railways in the Second World War"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Britain's Railways in the Second World War\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("A fascinating account of the British Railways system’s vital role in the defense of the country and support of the Allied forces during WWII.")]), _c('br'), _c('br'), _vm._v("The outbreak of the Second World War had an enormous effect on the railway system in Britain. The ‘Big Four’ companies put aside differences and worked together for the war effort. The logistics of transporting troops during the evacuation of Dunkirk and the preparations for D-Day were unprecedented. Meanwhile, they had to cope with the new and constant threat of aerial bombing. As a result, the railway system effectively served as another branch of the military."), _c('br'), _c('br'), _vm._v("At the end of the war, Winston Churchill likened London to a large animal, declaring that what kept the animal alive was its transport system. The metaphor could have been applied to the whole of Britain, and its most vital transport system was the railway. This book brings to light the often-forgotten stories of the brave men and women who went to work on the railways and put their lives on the line.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Michael Foley\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Pen and Sword Transport\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0